/* eslint-disable no-undef */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
/* eslint-disable no-sequences */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-param-reassign */

import mixpanel from 'mixpanel-browser';
import { config } from '../../config';
import { isProd } from './utils';

const webAppId = isProd()
  ? config.APPSFLYER_WEB_APP_PROD_ID
  : config.APPSFLYER_WEB_APP_TEST_ID;

export const initializeAppsFlyer = () => {
  !(function (t, e, n, s, a, c, i, o, p) {
    (t.AppsFlyerSdkObject = a),
      (t.AF =
        t.AF ||
        function () {
          (t.AF.q = t.AF.q || []).push(
            [Date.now()].concat(Array.prototype.slice.call(arguments))
          );
        }),
      (t.AF.id = t.AF.id || i),
      (t.AF.plugins = {}),
      (o = e.createElement(n)),
      (p = e.getElementsByTagName(n)[0]),
      (o.async = 1),
      (o.src = `https://websdk.appsflyer.com?${
        c.length > 0 ? `st=${c.split(',').sort().join(',')}&` : ''
      }${i.length > 0 ? `af_id=${i}` : ''}`),
      p.parentNode.insertBefore(o, p);
  })(window, document, 'script', 0, 'AF', 'pba', {
    pba: { webAppId },
  });
  const mixpanelDistinctId = mixpanel.get_distinct_id();
  if (mixpanelDistinctId) {
    window.AF('pba', 'setCustomerUserId', mixpanelDistinctId);
  }
};

export const registerAppsFlyerSignUpEvent = () => {
  window.AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'sign_up_success',
  });
};
